"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Drawer = void 0;
var _react = _interopRequireWildcard(require("react"));
var _styles = require("./styles");
var _lodash = require("lodash");
var _all = require("gsap/all");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
_all.gsap.registerPlugin(_all.ScrollTrigger);
const Drawer = ({
  items,
  initTimelines,
  scrollContainerId
}) => {
  const itemsRef = (0, _react.useRef)([]);
  const tlsRef = (0, _react.useRef)([]);
  itemsRef.current = Array(items.length).fill().map((_, i) => itemsRef[i] || (0, _react.createRef)());
  tlsRef.current = Array(items.length).fill().map((_, i) => itemsRef[i] || (0, _react.createRef)());
  const onResize = () => {
    (0, _lodash.forEach)(tlsRef.current, ({
      current
    }, i) => {
      if (current) {
        current?.scrollTrigger?.kill(true);
        current?.pause(0).kill(true);
        _all.gsap.set(itemsRef.current[i].current, {
          clearProps: true
        });
      }
    });
    setTimeout(initTl, 200);
  };
  const initTl = () => {
    if (window.innerWidth >= 768) {
      (0, _lodash.forEach)(itemsRef.current, ({
        current
      }, i) => {
        if (i < items.length) {
          let scrollTriggerOptions = {
            trigger: current,
            start: `top 60px`,
            end: `+=${i === items.length - 1 ? 0 : window.innerHeight - 60}px`,
            pin: current,
            scrub: true,
            pinSpacing: false
          };
          if (scrollContainerId && document.querySelector(`#${scrollContainerId}`)) {
            scrollTriggerOptions.scroller = document.querySelector(`#${scrollContainerId}`);
          }
          tlsRef.current[i].current = _all.gsap.timeline({
            scrollTrigger: scrollTriggerOptions
          });
        }
      });
    }
  };
  (0, _react.useEffect)(() => {
    if (initTimelines === true) {
      initTl();
      const onResizeDb = (0, _lodash.debounce)(onResize, 200);
      window.addEventListener('resize', onResizeDb);
    }
  }, [initTimelines]);
  return _react.default.createElement(_styles.Container, null, items?.map((item, i) => _react.default.createElement("div", {
    ref: itemsRef.current[i],
    key: `image--${i}`
  }, _react.default.createElement(_styles.ImageWrapper, null, _react.default.createElement(_styles.Image, {
    src: item.src,
    srcSet: item.srcSet,
    alt: item.src
  })))));
};
exports.Drawer = Drawer;
//# sourceMappingURL=index.js.map